"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "authReducer", {
  enumerable: true,
  get: function get() {
    return _reducer.default;
  }
});
Object.defineProperty(exports, "authState", {
  enumerable: true,
  get: function get() {
    return _state.default;
  }
});
Object.defineProperty(exports, "authSaga", {
  enumerable: true,
  get: function get() {
    return _sagas.default;
  }
});
exports.authActions = void 0;

var authActions = _interopRequireWildcard(require("./actions"));

exports.authActions = authActions;

var _reducer = _interopRequireDefault(require("./reducer"));

var _state = _interopRequireDefault(require("./state"));

var _sagas = _interopRequireDefault(require("./sagas"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}